import React from 'react';

import * as css from './index.module.css';

export default function Modal({ visible, content, handleExitModal, handleClickingOutsideModal, handleEscapingModal }) {
    if (!visible) {
        return null;
    }

    return <div className={css.modal} onKeyDown={handleEscapingModal} onClick={handleClickingOutsideModal}>
        <div className={css.content}>
            <img className={css.modalBody} src={content} />
            <button className={css.close} onClick={handleExitModal} />
        </div>
    </div>;
}
